import { render } from "./Region.vue?vue&type=template&id=edfd5d3a&scoped=true&ts=true"
import script from "./Region.ts?vue&type=script&lang=ts"
export * from "./Region.ts?vue&type=script&lang=ts"

import "./Region.scss?vue&type=style&index=0&id=edfd5d3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfd5d3a"]])

export default __exports__